import { Editor, Transforms } from 'slate';
import { splitedTable } from '../selection';
import { createRow } from '../creator';

export function insertAbove(table, editor) {
  const { selection } = editor;
  if (!selection || !table) return;

  const yIndex = table[1].length;

  const { gridTable, getCol } = splitedTable(editor, table);

  const [startCell] = Editor.nodes(editor, {
    match: n => n.type === 'td',
  });

  const [insertPositionCol] = getCol(
    (c) => c?.cell?.key === startCell[0]?.key && c.isReal
  );

  let checkInsertEnable = true;
  const insertYIndex = insertPositionCol?.path[yIndex];
  const insertCols = new Map();

  gridTable[insertYIndex]?.forEach((col) => {
    if (!col.isReal) {
      const [originCol] = getCol(
        (c) => c.isReal && c.cell.key === col.cell.key
      );

      if (originCol.path[yIndex] === insertYIndex) {
        insertCols.set(originCol.cell.key || Math.random().toString(36).substring(2, 10), originCol);
      } else {
        checkInsertEnable = false;
        return;
      }
    } else {
      insertCols.set(col.cell.key || Math.random().toString(36).substring(2, 10), col);
    }
  });

  if (!checkInsertEnable) {
    return;
  }

  const newRow = createRow(insertCols.size);

  [...insertCols.values()].forEach((col, index) => {
    newRow.children[index].colspan = col.cell.colspan || 1;
  });

  const [[, path]] = Editor.nodes(editor, {
    match: n => n.type === 'tr',
  });

  Transforms.insertNodes(editor, newRow, {
    at: path,
  });
}
